<template>
	<div class="col-12">
		<h3>{{ $t('marketplace.amount_to_pay') }}</h3>
		<div v-for="(amount, index) in amounts" :key="index">
			<p>{{ amount.is_now ? nowLabel : amount.date_label }} : {{ amount.formatted }}</p>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: "AmountsToPay",
		props: {
			/**
			 * Montants à régler, déjà formatés par l'appelant.
			 * Chaque entrée : { is_now, date_label, formatted }
			 */
			amounts: {
				type: Array,
				default: () => ([])
			},
			/** Libellé affiché à la place de la date pour les échéances déjà exigibles. */
			nowLabel: {
				type: String,
				required: true
			}
		}
	}
</script>
